import {
  type ApplicationConsumerSummary,
  ApplicationConsumerSummarySchema,
  type OrgSummary,
  OrgSummarySchema,
} from '../../../types'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type SpaceGetApplicationsResponsePayload = {
  applications: ApplicationConsumerSummary[]
  organization?: OrgSummary
}

export const SpaceGetApplicationsResponsePayloadSchema: CborSchema<SpaceGetApplicationsResponsePayload> =
  defineCborSchema<SpaceGetApplicationsResponsePayload>({
    applications: CborField({ key: 0, arrayItemType: ApplicationConsumerSummarySchema }),
    organization: CborField({ key: 1, required: false, type: OrgSummarySchema }),
  })
